import React from "react";

const PreviewTemplate = ({ setShowTemplate , thumbnail_url, preview_url  }) => {

    // console.log(thumbnail_url, preview_url)
    const playMovie = (e) => {
        e.target.play();
        e.target.muted = true;
      };
    
      const stopMovie = (e) => {
        e.target.pause();
        e.target.load();
      };



  return (
    <>
      {/* <!-- Modal --> */}
      <div
        className="modal fade show d-block"
        id="modalcreatevideo"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modalcreatevideoTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="font18">
                Template Preview
              </h4>
              <button
                type="button"
                className="close"
                onClick={() => {
                    setShowTemplate(false);
                }}
              >
                <i
                  className="fas fa-times"
                  style={{ fontSize: "20px", color: "#cacccf" }}
                ></i>
              </button>
            </div>
            <div className="modal-body p-0">
              <div className="videos">
                <div className="video_rw p-4">

                        <video
                            src={preview_url}
                            poster={thumbnail_url}
                            loop
                            width="100%"
                            onMouseOver={playMovie}
                            onMouseOut={stopMovie}
                            // className="no-coursor"
                            // className="cursor"
                        />

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreviewTemplate;
